import React from 'react';
import landingDesktop from '../assets/mypictorlanding.png';
import landingMobile from '../assets/mypictorlanding-mobile.png';

export default function OrganizeSection() {
  return (
    <section className="organize-section">
      <div className="section-container">
        <div className="section-content">
          <h2 className="section-title">AI-powered search finds what you need instantly.</h2>
          <p className="section-text">
            <strong>MyPictor transforms your photo chaos into organized memories.</strong> 
            Search by anything—find "beach photos from 2020" or "photos with my dog" in seconds. 
            No more scrolling through thousands of images.
          </p>
        </div>
        <div className="section-image-wrapper">
          <img 
            src={landingDesktop}
            srcSet={`${landingMobile} 768w, ${landingDesktop} 1920w`}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt="AI-powered search" 
            className="section-image"
          />
        </div>
      </div>
    </section>
  );
}
